<template>
    <AppLayout>
        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-3">
                <div class="bg-white p-5 rounded-sm border border-gray-200">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-lg font-bold">
                            <span class="underline">Utilisateur:</span> <span class="text-sky">N°{{ userShow.code }}</span>
                        </div>
                        <div v-if="!userShow.is_admin" class="form-switch">
                            <input @click="enableUpdateProfil()"  type="checkbox" id="toggle" class="sr-only" x-model="checked">
                            <label class="bg-sky-400" for="toggle">
                                <span class="bg-white shadow-sm" aria-hidden="true"></span>
                                <span class="sr-only">Activer la modifcation</span>
                            </label>
                        </div>
                    </div>
                    <ProfilUserEditable v-if="profileIsEditable" :user="userShow" :roles="roles" />
                    <ProfilUserNotEditable v-else :user="userShow" />
                </div>
            </div>
            <div class="col-span-9">
                <div class="mb-1 pb-1">
                    <ul class="text-sm font-medium flex flex-nowrap overflow-x-scroll no-scrollbar space-x-2">
                        <li>
                            <Link :href="route('users.show', $page.props.userShow)"
                                class="whitespace-nowrap flex items-center p-2 mr-4 last:mr-0 first:pl-2 sm:first:pl-4 lg:first:pl-6 last:pr-2 sm:last:pr-4 lg:last:pr-6 rounded-md"
                                :class="route().current('users.show') ? 'bg-sky hover:bg-sky-400 text-white font-bold' : 'bg-gray-100 text-gray-500 hover:bg-sky-400 hover:text-white'"
                            >
                                <ArchiveIcon class="w-5 h-5 shrink-0 fill-current mr-2" />
                                <span>Colis envoyés</span>
                            </Link>
                        </li>
                        <li>
                            <Link :href="route('users.requests.show', $page.props.userShow)"
                                class="whitespace-nowrap flex items-center p-2 mr-4 last:mr-0 first:pl-2 sm:first:pl-4 lg:first:pl-6 last:pr-2 sm:last:pr-4 lg:last:pr-6 rounded-md"
                                :class="route().current('users.requests.show') ? 'bg-sky hover:bg-sky-400 text-white font-bold' : 'bg-gray-100 text-gray-500 hover:bg-sky-400 hover:text-white'"
                            >
                                <ClipboardListIcon class="w-5 h-5 shrink-0 fill-current mr-2" />
                                <span>Demandes envoyées</span>
                            </Link>
                        </li>
                        <li>
                            <Link :href="route('users.items.show', $page.props.userShow)"
                                class="whitespace-nowrap flex items-center p-2 mr-4 last:mr-0 first:pl-2 sm:first:pl-4 lg:first:pl-6 last:pr-2 sm:last:pr-4 lg:last:pr-6 rounded-md"
                                :class="route().current('users.items.show')
                                    ? 'bg-primaryOrange hover:bg-primaryOrange-300 text-white font-bold'
                                    : 'bg-primaryOrange-50 text-gray-500 hover:bg-primaryOrange hover:text-white border border-primaryOrange-200'"
                            >
                                <ShoppingBagIcon class="w-5 h-5 shrink-0 fill-current mr-2" />
                                <span>Articles achetés</span>
                            </Link>
                        </li>
                    </ul>
                </div>

                <slot />
            </div>
        </div>
    </AppLayout>
</template>

<script>
    import { defineComponent } from 'vue'
    import AppLayout from '@/Layouts/AppLayout.vue'
    import { Link } from '@inertiajs/inertia-vue3';
    import ProfilUserEditable from '@/Components/ProfilUserEditable.vue';
    import ProfilUserNotEditable from '@/Components/ProfilUserNotEditable.vue';
    import { ArchiveIcon, ShoppingBagIcon, ClipboardListIcon } from '@heroicons/vue/solid'

    export default defineComponent({
        components: {
            Link,
            AppLayout,
            ArchiveIcon,
            ShoppingBagIcon,
            ClipboardListIcon,
            ProfilUserEditable,
            ProfilUserNotEditable
        },


         props: {
            roles: Array,
            userShow: Object,
        },

        data() {
            return {
                profileIsEditable: false,
                form: this.$inertia.form({
                    name: this.userShow.name,
                    email: this.userShow.email,
                    phone: this.userShow.phone,
                    dial_code: this.userShow.dial_code,
                    country_code: this.userShow.country_code
                })
            }
        },

        methods: {
            enableUpdateProfil() {
                this.profileIsEditable = !this.profileIsEditable
            },
        }
    })
</script>
